import React, { useRef } from 'react';
import Immutable from 'immutable';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
  Container,
  WysiwygField,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Paragraph,
} from '@uncinc/react-drupal-core';

import {
  GetStarted,
  Share,
} from '../../../../components';

import './style.scss';

import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_TABLET,
} from '../../../../config/constants';
import PrevNext from '../../../../components/PrevNext';

const TaxonomyMilestoneDetail = ({ entity }) => {
  const { t } = useTranslation();
  const vocabulary = entity.getIn(['vid', 0, 'target_id']);
  const title = entity.getIn(['name', 0, 'value']);
  const description = entity.getIn(['description', 0, 'processed']);
  const subtitle = entity.getIn(['field_sub_title', 0, 'value']);
  const label = entity.getIn(['field_milestone_label', 0, 'value']);
  const paragraphs = entity.getIn(['field_paragrafen']);
  const tid = entity.getIn(['tid', 0, 'value']);
  const parentUrl = useSelector((state) => state.getIn(['entity', 'breadcrumbs', 1, 'url']));
  const getStartedContent = entity.getIn(['field_get_started_content'], Immutable.Map());
  const getStartedRef = useRef();

  return (
    <div className={`TaxonomyMilestone TaxonomyMilestone--${vocabulary}`}>
      <Container>
        <div className="TaxonomyMilestone__timeline__left" />
        <div className="TaxonomyMilestone__timeline__right" />
        <div className="TaxonomyMilestone__hero">
          {entity.getIn(['field_media_image', 0]) && (
            <Image
              lazyload={false}
              className="TaxonomyMilestone__hero__image"
              includeWebP
              src={{
                [SCREEN_MOBILE]: entity.getIn(['field_media_image', 0, 'styles', 'hero_mobile']),
                [SCREEN_TABLET]: entity.getIn(['field_media_image', 0, 'styles', 'hero_tablet']),
                [SCREEN_NORMAL]: entity.getIn(['field_media_image', 0, 'styles', 'hero_desktop']),
              }}
              alt={entity.getIn(['field_media_image', 0, 'alt'], '')}
            />
          )}
        </div>
        <div className="TaxonomyMilestone__content__wrapper row">
          <div className="col-12 col-lg-10 offset-lg-1">
            <div className="TaxonomyMilestone__content">

              <h1>{title}</h1>

              {subtitle && (
                <div className="TaxonomyMilestone__subtitle">
                  {subtitle}
                </div>
              )}

              {label && (
                <div className="TaxonomyMilestone__label">
                  {label}
                </div>
              )}

              {description && (
                <WysiwygField
                  property="schema:text"
                  className="TaxonomyMilestone__body"
                  html={description}
                />
              )}
            </div>
          </div>
        </div>
      </Container>

      {paragraphs.size > 0 && (
        <div className="Paragraphs">
          {
            paragraphs.map((item) => {
              const paragraphId = item.get('target_id');
              const paragraph = item.getIn(['entity']);

              return (
                <Paragraph key={paragraphId} entity={paragraph} id={paragraphId} fromMijlpalenTaxonomy />
              );
            })
          }
        </div>
      )}

      <PrevNext originTid={tid} parentUrl={parentUrl} parentUrlTitle={t('milestones.all_milestones')} title={t('milestones.show_other_milestones')} vocabulary="milestones" />

      <GetStarted
        title={entity.getIn(['field_get_started_title', 0, 'value'])}
        subtitle={entity.getIn(['field_get_started_subtitle', 0, 'value'])}
        content={getStartedContent}
        getStartedRef={getStartedRef}
      />

      <Container>
        <div className="row">
          <div className="col-12 col-lg-8 offset-lg-2">
            <Share pageTitle={entity.getIn(['title', 0, 'value'], '')} />
          </div>
        </div>
      </Container>

    </div>
  );
};

export default TaxonomyMilestoneDetail;
